import React from 'react';
import {
  InvitationAcceptanceAction,
  InvitationAcceptanceContent,
  InvitationAcceptanceIcon,
  InvitationAcceptanceMessage,
  InvitationAcceptanceTitle,
  InvitationAcceptanceViewport,
} from './styles';
import { InvitationAcceptanceStatusViewProps } from './types';

export function InvitationAcceptanceStatusView({
  acceptanceIcon,
  acceptanceMessage,
  acceptanceTitle,
  announceAsStatus = false,
  primaryAction,
}: InvitationAcceptanceStatusViewProps) {
  return (
    <InvitationAcceptanceViewport>
      <InvitationAcceptanceContent
        role={announceAsStatus ? 'status' : undefined}
      >
        <InvitationAcceptanceIcon>{acceptanceIcon}</InvitationAcceptanceIcon>
        {acceptanceTitle && (
          <InvitationAcceptanceTitle>
            {acceptanceTitle}
          </InvitationAcceptanceTitle>
        )}
        <InvitationAcceptanceMessage>
          {acceptanceMessage}
        </InvitationAcceptanceMessage>
        {primaryAction && (
          <InvitationAcceptanceAction
            color="primary"
            onClick={primaryAction.onClick}
            variant="contained"
          >
            {primaryAction.label}
          </InvitationAcceptanceAction>
        )}
      </InvitationAcceptanceContent>
    </InvitationAcceptanceViewport>
  );
}
